import React from "react";
import Draggable from "react-draggable";
import { Resizable } from "react-resizable";

export default class CustomDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
  }

  state = {
    infoHidden: false,
    isDragging: false,
    ratio: 1,
  };

  componentDidMount() {
    const img = new Image();
    img.src = `data:image/png;base64,${this.props.qrImage}`;
    img.onload = () => {
      this.setState({ ratio: img.width / img.height });
    };
  }

  getCurrentSize = () => {
    const { lowerLeftX, lowerLeftY, upperRightX, upperRightY } =
      this.props.qrPosition;
    const width = upperRightX - lowerLeftX;
    const height = upperRightY - lowerLeftY;
    return { width, height };
  };

  onControlledDrag = (_, { x, y }) => {
    const element = this.nodeRef.current;
    if (!element) return;

    const width = element.offsetWidth;
    const height = element.offsetHeight;

    this.props.setQrPosition({
      x,
      y,
      lowerLeftX: x,
      lowerLeftY: Math.abs(y),
      upperRightX: x + width,
      upperRightY: Math.abs(y) + height,
    });
  };

  onResize = (_, { size }) => {
    const { x, y } = this.props.qrPosition;
    const { ratio } = this.state;

    const width = size.width;
    const height = width / ratio;

    if (
      Math.abs(y) + height <= this.props.pdfSize.height &&
      x + width <= this.props.pdfSize.width
    ) {
      this.props.setQrPosition({
        ...this.props.qrPosition,
        upperRightX: x + width,
        upperRightY: Math.abs(y) + height,
      });
    }
  };

  render() {
    const { x, y } = this.props.qrPosition;
    const { infoHidden, isDragging } = this.state;
    const { width, height } = this.getCurrentSize();

    return (
      <Draggable
        nodeRef={this.nodeRef}
        axis="both"
        bounds="parent"
        handle=".handle"
        scale={1}
        position={{ x, y }}
        onDrag={this.onControlledDrag}
        onStart={() => this.setState({ isDragging: true })}
        onStop={() => this.setState({ isDragging: false })}
        disabled={this.props.isDetailMode}
      >
        <div
          className="absolute bottom-0"
          ref={this.nodeRef}
          style={{ width, height }}
        >
          {!this.props.isDetailMode ? (
            <Resizable
              width={width}
              height={height}
              onResize={this.onResize}
              disabled={this.props.isDetailMode}
            >
              <div className="relative" style={{ width, height }}>
                <img
                  alt="QR Image"
                  src={`data:image/png;base64,${this.props.qrImage}`}
                  className={`pointer-events-none select-none box-border ${
                    this.props.isDetailMode ? "" : "border-2 border-blue-600"
                  }`}
                  style={{ width, height }}
                />

                <div
                  className="absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent handle"
                  style={{ width, height }}
                >
                  <div
                    className={`bg-white w-16 text-blue-600 text-[8px] text-center font-semibold select-none ${
                      infoHidden || this.props.isDetailMode || isDragging
                        ? "hidden"
                        : ""
                    }`}
                  >
                    Drag to move
                  </div>
                </div>
              </div>
            </Resizable>
          ) : (
            <div className="relative" style={{ width, height }}>
              <img
                alt="QR Image"
                src={`data:image/png;base64,${this.props.qrImage}`}
                className={`pointer-events-none select-none box-border ${
                  this.props.isDetailMode ? "" : "border-2 border-blue-600"
                }`}
                style={{ width, height }}
              />

              <div
                className="absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent handle"
                style={{ width, height }}
              >
                <div
                  className={`bg-white w-16 text-blue-600 text-[8px] text-center font-semibold select-none ${
                    infoHidden || this.props.isDetailMode || isDragging
                      ? "hidden"
                      : ""
                  }`}
                >
                  Drag to move
                </div>
              </div>
            </div>
          )}
        </div>
      </Draggable>
    );
  }
}
